import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const hpValue = (formData.get('phone_alt') as string || '').trim();
    if (hpValue) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      return;
    }

    setStatus('loading');
    try {
      const response = await fetch('https://readdy.ai/api/form/d9qrpkfnahb7382oved0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await response.text();
      if (response.ok) {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，最新爆料将第一时间送达。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('订阅失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="w-full relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20background%20with%20warm%20red%20and%20amber%20gradients%2C%20abstract%20news%20media%20theme%2C%20mysterious%20glowing%20atmosphere%2C%20luxurious%20dark%20textures%2C%20elegant%20modern%20design%20with%20subtle%20patterns&width=1800&height=500&seq=cta-bg-newsletter&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-900/85"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-200 text-sm mb-6">
            <i className="ri-mail-send-line"></i>
            <span>爆料速递</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white">
            不错过任何一条<strong className="text-primary-400">黑料</strong>
          </h2>
          <p className="mt-4 text-white/60 text-base leading-relaxed">
            订阅黑料网邮件通知，最新爆料、独家内容第一时间推送至您的邮箱
          </p>
          {status === 'success' ? (
            <div className="mt-8 p-4 bg-primary-500/20 border border-primary-500/30 rounded-xl">
              <p className="text-primary-200 text-sm">{message}</p>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              className="mt-8 flex flex-col sm:flex-row items-center gap-3 max-w-lg mx-auto"
            >
              <div className="hp-field-wrap">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入您的邮箱地址"
                required
                className="flex-1 w-full px-5 py-3.5 bg-white/10 border border-white/20 rounded-full text-white placeholder:text-white/40 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap disabled:opacity-60"
              >
                {status === 'loading' ? '订阅中...' : '立即订阅'}
              </button>
            </form>
          )}
          {status === 'error' && (
            <p className="mt-3 text-red-400 text-sm">{message}</p>
          )}
          <p className="mt-4 text-xs text-white/30">
            我们尊重您的隐私，绝不泄露您的邮箱信息
          </p>
        </div>
      </div>
    </section>
  );
}